import { render, staticRenderFns } from "./service-manage-attr.vue?vue&type=template&id=0eebc94a&scoped=true&"
import script from "./service-manage-attr.vue?vue&type=script&lang=js&"
export * from "./service-manage-attr.vue?vue&type=script&lang=js&"
import style0 from "./service-manage-attr.vue?vue&type=style&index=0&id=0eebc94a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eebc94a",
  null
  
)

export default component.exports